import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { toogleReload } from '../../../Utils/reloadSlice';
import { toogleDailyQuotes } from '../../../Utils/dailyQuotesSlice';
import axios from 'axios';

const EditDailyQuotes = ({setEditDailyQuote, editDailyQuote}) => {
    const [quotesHindi, setQuotesHindi] = useState(editDailyQuote.dailyQoutesHindi || "");
    const [quotesEnglish, setQuotesEnglish] = useState(editDailyQuote.dailyQoutesEnglish || "");
    const [image, setImage] = useState(editDailyQuote.dailyQoutesImage || "");
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();

    const toggleFormHandler = () => {
        dispatch(toogleDailyQuotes());
        setQuotesEnglish("");
        setQuotesHindi("");
        setLoading(false);
    }

    const uploadFile = async (type) => {
        const data = new FormData();
        data.append("file", image);
        data.append("upload_preset", 'app_image_preset');
    
        try{
            const resourceType = type === 'image'? 'image' : 'video';
            const api = `https://api.cloudinary.com/v1_1/ddbrxrvat/${resourceType}/upload`;
            const res = await axios.post(api, data);
            const { secure_url } = res.data;
            return secure_url;
        } catch (err) {
            console.log(err);
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            setLoading(true);
            if(image !== editDailyQuote.dailyQoutesImage){
                var imgUrl = await uploadFile('image');
            }
            await fetch(`https://app-api.mokx.org/api/v1/daily_quotes/${editDailyQuote._id}`, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                "dailyQoutesHindi": quotesHindi,
                "dailyQoutesEnglish": quotesEnglish,
                "dailyQoutesImage": imgUrl ? imgUrl : image
            }),
            });
            dispatch(toogleReload());
        } catch (error) {
        console.error("Error updating data:", error);
        }
        dispatch(toogleDailyQuotes());
        setQuotesEnglish("");
        setQuotesHindi("");
        setLoading(false);
    }

    return (
        <div tabIndex="-1" className="max-h-full fixed top-0 left-0 right-0 z-50 w-full p-4 overflow-x-hidden overflow-y-auto md:inset-0">
            <div className="relative w-full max-w-lg max-h-full mx-auto">
                <div className="relative bg-white rounded-lg shadow">
                    <div className='flex items-center justify-between px-6 py-4'>
                        <h1 className='text-[#231F20] text-xl leading-8 font-figtree font-semibold'>Edit Daily Quotes</h1>
                        <button type="button" className="text-[#999CA0]" onClick={() => toggleFormHandler()}>
                            <svg className="w-3 h-3" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
                                <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"strokeWidth="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"/>
                            </svg>
                        </button>
                    </div>
                    <div className='w-full h-[1px] bg-[#F2F2F2]'></div>
                    <div className='p-6 flex flex-col gap-6'>     
                        <form onSubmit={handleSubmit} className='flex flex-col gap-5'>
                            <div className='flex flex-col'>
                                <label htmlFor="heading" className='text-[#231F20] text-base font-figtree font-normal mb-2'>Enter Hindi Quote<span className='text-[#ff3535] text-lg'>*</span></label>
                                <div className='w-full px-4 py-3 rounded-lg border border-[#F2F2F2]'>
                                    <input
                                    required
                                    type="text"
                                    name="heading"
                                    onChange={(e) => setQuotesHindi(e.target.value)}
                                    value={quotesHindi}
                                    placeholder='Eg. प्राणे सर्वं प्रतिष्ठितम्'
                                    className='w-full text-[#999CA0] text-base font-figtree font-normal focus:outline-none'
                                    />
                                </div>
                            </div>
                            <div className='flex flex-col'>
                                <label htmlFor="content" className='text-[#231F20] text-base font-figtree font-normal mb-2'>Enter English Quote<span className='text-[#ff3535] text-lg'>*</span></label>
                                <div className='w-full px-4 py-3 rounded-lg border border-[#F2F2F2]'>
                                    <input
                                    required
                                    type="text"
                                    name="content"
                                    onChange={(e) => setQuotesEnglish(e.target.value)}
                                    value={quotesEnglish}
                                    placeholder='Eg. Everything depends on the prana.'
                                    className='w-full text-[#999CA0] text-base font-figtree font-normal focus:outline-none'
                                    rows="4"
                                    />
                                </div>
                            </div>
                            <div className='flex flex-col'>
                                    <label htmlFor="image" className='text-[#231F20] text-base font-figtree font-normal mb-2'>Image<span className='text-[#ff3535] text-lg'>*</span></label>
                                    <div className='w-full px-4 py-3 rounded-lg border border-[#F2F2F2]'>
                                        <input
                                            type="file"
                                            name="image"
                                            onChange={(e) => setImage((prev) => e.target.files[0])}
                                            accept="image/*"
                                            className='w-full text-[#999CA0] text-base font-figtree font-normal focus:outline-none'
                                        />
                                    </div>
                                    {image!=="" && <div className=' flex justify-center items-center mt-2'>
                                        <img className='w-20 h-20' src={image === editDailyQuote.dailyQoutesImage ? editDailyQuote.dailyQoutesImage : URL.createObjectURL(image)} alt='' />
                                    </div>}
                                </div>
                            <div className='w-full h-[0.5px] bg-[#F2F2F2]'></div>
                            <div className='text-center'>
                                <button type="submit" disabled={loading} className='w-[24%] bg-[#3E84F8] disabled:opacity-50 rounded-[8px] px-4 py-2 text-[#FFF] text-sm font-figtree font-semibold'>
                                    {!loading ? 'Update' : 'Updating'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default EditDailyQuotes;